import * as React from 'react';
import { useParams } from 'react-router-dom';
import { AddressForm } from '.';
import { DashboardContainer } from 'views/Dashboard/components';
import { useContext, useState } from 'react';
import { Box, Button, Alert, Card, CardContent} from '@mui/material';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch} from 'react-redux';
import { selectAddressById, addressUpdated } from 'features/addresses/addressesSlice';
import ContentContext from 'layouts/ContentContext'
import ScrollToContentTop from 'utils/ScrollToContentTop'
import { LinearProgress } from '@mui/material';
import { useNavigate } from 'react-router';
import parseDate from 'utils/parseDate';

export default function EditAddressForm(props){

    const contentDiv = useContext(ContentContext);

    const params = useParams();

    console.log("PARAMS", params);
    const id = params.id

    const address = useSelector((state) => selectAddressById(state, id));
    
    const updateStatus = useSelector((state) => state.addresses.editing.status);
    const updateError = useSelector((state) => state.addresses.editing.error);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isSaving, setIsSaving] = useState(false);

    const updateAddress = a => {
        const payload = { id: a.id, address: a }
        setIsSaving(true);
        dispatch(addressUpdated(payload)).then(result => {
            if(result.type === "addresses/addressUpdated/fulfilled"){
                
                setIsSaving(false);
                ScrollToContentTop(contentDiv);
                navigate("/dashboard/customers");
            }
            if(result.type === "addresses/addressUpdated/rejected"){
                ScrollToContentTop(contentDiv);
            }
        });    
    }

    return(
        <>
        <DashboardContainer>
            
            <Box
                sx={{
                display: 'flex',
                justifyContent: 'space-between',
                columnGap: 1
                }}
            >
                <Box>
                    <Link to="/dashboard/customers">
                        <Button
                        sx={{ mr: "auto" }}
                        color="success"
                        variant="outlined"
                        size="small" 
                        >
                        Back
                        </Button>
                    </Link>
                </Box>
                { address &&
                <Box sx={{ display:"flex",columnGap: 1 }}>

                    <Link to={"printAddressDetails/" + address.id }>
                        <Button sx={{ mx: 1 }} size="small" >
                        Print
                        </Button>
                    </Link>

                </Box>
                }
            </Box>
            <Box sx={{ width: '100%', mt:3 }}>
            
            { updateError && <Alert severity="error">{updateError}</Alert>}
            { isSaving && 
                <>
                <LinearProgress />
                <Alert severity="info">STATUS : {updateStatus}</Alert>
                </>
            }   
            { address === undefined && <Alert severity="error">Address with given ID does not exist.</Alert> }
            { address &&
            <>
            <Alert variant="outlined" severity="success">DATE : { parseDate(address.created_at) }</Alert>
            <Card sx={{mt:2}}>
                <CardContent>
                    <AddressForm 
                        editMode={true} 
                        model={address}
                        onAction={updateAddress}
                        submitLabel="Update"
                    />                   
                </CardContent>
            </Card>
           
         
            </>
            }

        </Box>
        </DashboardContainer>
        </>
    )

}

